import { CtaTypeEnum } from 'app/data/types/content';

export enum AttachableSurveyTypeEnum {
  GENERAL = 'GENERAL',
  NPS = 'NPS',
}

export interface Attachable {
  label: string;
  type: CtaTypeEnum;
  url?: string;
  attachable_amenity_uuid?: string;
  attachable_company_uuid?: string;
  attachable_content_uuid?: string;
  attachable_survey_type?: AttachableSurveyTypeEnum;
  attach_secondary_content?: boolean;
  isRsvp?: boolean;
  isClaim?: boolean;
  isClaimable?: boolean;
  datetime?: Date;
  atLimitText?: string;
  capacity?: number;
  maxClaimsTotal?: number;
  maxClaimsPerUser?: number;
  userCount?: number;
  count?: number;
  contentTitle?: string;
  ctaDisplayStartAt?: Date;
  ctaDisplayEndAt?: Date;
}

export interface Category {
  id?: number;
  category_uuid: string;
  category_name: string;
  category_weight?: number;
  typename?: string;
  amenities?: Array<Amenity>;
}

interface Amenity {
  id?: number;
  amenity_uuid: string;
  user_rating?: number;
  amenity_name: string;
  image_url: string;
  image_alt_text?: string;
  feedback_count?: number;
  average_rating?: number;
  description?: string;
  category?: number | string;
  categories?: Array<Category>;
  icon_class?: string;
  amenity_weight?: number;
}

export const UTILITY_NAMES = {
  MOBILE_ACCESS: 'MobileAccess',
  CONCIERGE: 'Concierge',
  SAFETY: 'Safety',
  VISITOR_REGISTRATION: 'Visitor Registration',
  VISITOR_REGISTRATION_MINIAPP: 'Visitor Registration MiniApp',
  RESOURCE_RESERVATION: 'Resource Reservation',
  AMENITIES: 'Amenities',
  VORNADO_AMENITIES: 'Building Information',
  SERVICE_REQUESTS: 'Service Requests',
  RESERVE_SPACE: 'Reserve Space',
  TRANSIT: 'Transit',
  TRANSIT_SCREEN: 'TransitScreen',
  FOOD_TRUCK: 'Food Truck Map',
  TENANT_SERVICES: 'Tenant Services',
  COMPANIES: 'Companies',
  CLOUDGATE: 'Cloudgate',
  RESOURCE_BOOKING_V2: 'Resource Booking V2',
  TENANT_SATISFACTION: 'Tenant Satisfaction',
  WALLET: 'Wallet MiniApp',
  SECONDARY_CONTENT: 'Secondary Content',
  COMMUNITY_FORUM: 'Community Forum',
  ECOBEE: 'Ecobee MiniApp',
  LUTRON: 'Lutron MiniApp',
};

export const IN_APP_CONTENT = {
  CONTENT: 'CONTENT',
  AMENITIES: 'AMENITIES',
  COMPANIES: 'COMPANIES',
};

export enum WEB_APP_NATIVE_PAGES {
  FEED = 'FEED',
  EVENTS= 'EVENTS',
  ABOUT = 'ABOUT',
  HELP = 'HELP',
  SECONDARY_CONTENT = 'SECONDARY_CONTENT',
}
